<template>
  <v-container>
    <div class="grey--text text--darken-1 text-h5 text-sm-h4 text-md-h3 text-l-h2 text-xl-h2 mt-2 mb-2">
      Contact us
    </div>

    <v-row flex>
      <v-col xl="4" lg="6" md="6" sm="9" cols="12">
        
        <v-card outlined>
          <v-form ref="form">

            <v-card-text>        
              <v-text-field 
                v-model="name"
                label="Name"
                :rules="[inputRules.required]"
                autofocus>            
              </v-text-field>  

              <v-text-field 
                v-model="email"
                label="Email"
                :rules="[inputRules.required, inputRules.email]">            
              </v-text-field>

              <v-textarea
                v-model="message"
                label="Message"
                :rules="[inputRules.required]">  
              </v-textarea>

            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn depressed @click="send" :loading="submitting" :disabled="submitting">
                Send
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from '@/firebase.config'

export default {
  name: "Contact",
  data() {
    return {
      name: '',
      email: '',
      message: '',
      submitting: false,
      inputRules: {
        required: value => !!value || 'Required',
        email: v => /.+@.+/.test(v) || 'Email must be valid'
      }
    }
  },
  methods: {
    async send() {
      if (this.$refs.form.validate()) {
        this.submitting = true
        const contactMessageData = { 
          name: this.name,
          email: this.email,
          message: this.message,
          created: firebase.firestore.Timestamp.now()
        }
        await this.$store.dispatch('addContactMessage', contactMessageData)
        
        this.$refs.form.reset()
        this.submitting = false
      this.$store.dispatch('storeSnackbarMessage', 'Message sent')
      }
    }
  },
}
</script>

